import React from 'react';
import { Box, Skeleton, Typography, MenuItem, Select, FormControl, InputLabel, Button } from '@mui/material';

const SkeletonExportResume = () => (
  <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    <Typography variant="h6" sx={{ mb: 1 }}>
      <Skeleton width="30%" />
    </Typography>
    <FormControl fullWidth>
      <InputLabel id="businessUnit-label">
        <Skeleton width="60%" />
      </InputLabel>
      <Select labelId="businessUnit-label" id="businessUnit">
        <MenuItem value="">
          <Skeleton width="100%" />
        </MenuItem>
      </Select>
    </FormControl>
    <FormControl fullWidth>
      <InputLabel id="format-label">
        <Skeleton width="40%" />
      </InputLabel>
      <Select labelId="format-label" id="format">
        <MenuItem value="">
          <Skeleton width="100%" />
        </MenuItem>
      </Select>
    </FormControl>
    <Button variant="contained" disabled sx={{ height: '40px', borderRadius: '8px' }}>
      <Skeleton width="100%" />
    </Button>
  </Box>
);

export default SkeletonExportResume;
